import Cookies from "js-cookie";
import { createActionType, createAsyncAction } from "./create-actions";

export const GET_NEW_TOKEN = createActionType("GET_NEW_TOKEN");

export const getNewToken = () =>
  createAsyncAction(GET_NEW_TOKEN, "/auth/refresh-token", "get", undefined, {
    Authorization: `Bearer ${Cookies.get("refreshToken")}`,
  });
